export default {
    personId: {
        ssn: true
    } 
}